import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);   // null = unknown, false = unauth, object = authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('goldcare_admin_token');
    if (!token) { setAdmin(false); setLoading(false); return; }
    try {
      const { data } = await api.get('/api/auth/me');
      setAdmin(data);
    } catch (e) {
      localStorage.removeItem('goldcare_admin_token');
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem('goldcare_admin_token', data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post('/api/auth/logout'); } catch (_) { /* noop */ }
    localStorage.removeItem('goldcare_admin_token');
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside <AuthProvider>');
  return ctx;
};
